import React from "react";
import { Snackbar, Alert } from "@mui/material";

/**
 * Common toast component for success / error messages.
 * Use in any page:
 * <Toast open={open} message="Saved" severity="success" onClose={handleClose} />
 */
const Toast = ({
  open,
  message,
  severity = "success",
  onClose,
  autoHideDuration = 3000,
  anchorOrigin = { vertical: "top", horizontal: "right" },
}) => {
  return (
    <Snackbar
      open={!!open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      container={typeof document !== 'undefined' ? document.body : undefined}
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 100, // Appear above dialogs/modals
      }}
    >
      <Alert severity={severity} onClose={onClose} sx={{ width: "100%" }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default Toast;

